export default () => ({
  graphWrapper: {
    margin: '30px 0',
  },
});
